import {
  USER_CHANNEL_GRANT_STARTED,
  USER_CHANNEL_GRANT_FINISHED,
  USER_CHANNEL_GRANT_FAILED,
  PUBLISH_MESSAGE,
  USER_CHANNEL_GRANT_APPIAN_STARTED,
  USER_CHANNEL_GRANT_APPIAN_FINISHED,
  USER_CHANNEL_GRANT_APPIAN_FAILED
} from "constants/actionTypes";

export const userChannelGrantStarted = (userId, token) => ({
  type: USER_CHANNEL_GRANT_STARTED,
  userId,
  token
});
export const userChannelGrantFinished = (payload, token) => ({
  type: USER_CHANNEL_GRANT_FINISHED,
  payload,
  token
});
export const userChannelGrantFailed = payload => ({
  type: USER_CHANNEL_GRANT_FAILED,
  payload
});
export const publishMessage = (message, channel) => ({
  type: PUBLISH_MESSAGE,
  message,
  channel
});
export const userChannelGrantAppianStarted = (token, techId) => ({
  type: USER_CHANNEL_GRANT_APPIAN_STARTED,
  token,
  techId
});
export const userChannelGrantAppianFinished = (authKey, techId) => ({
  type: USER_CHANNEL_GRANT_APPIAN_FINISHED,
  authKey,
  techId
});
export const userChannelGrantAppianFailed = () => ({
  type: USER_CHANNEL_GRANT_APPIAN_FAILED,
});


// WEBPACK FOOTER //
// ./src/actions/messageActions.js